import Vue from 'vue';
import { SwitchCity, SwitchCityField } from "@travelata-libs/travelata-frontend";
import { getPanelList, getCurrentCity } from './getPanelList';

export function mountSwitchCityToFooter() {
    const js = document.querySelector('.js-switch-city-footer');
    const cities = getPanelList();
    if(js && cities.length) {
        const currentCity = getCurrentCity(cities);
        new Vue({
            render: (h) =>
              h(SwitchCityField, {
                props: {
                    cities,
                    currentCity,
                    redirect: false,
                    buttonType: 'link'
                },
                on: {
                    change: (city: SwitchCity) => {
                        const foundCity = cities.find((c) => c.id === city.id);
                        foundCity?.el?.click();
                    }
                }
              }),
          }).$mount(js);
    }
}